import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Transfers API
export const transfersApi = {
  getAll: (params = {}) => axios.get(`${API}/transfers`, { params }),
  getById: (id) => axios.get(`${API}/transfers/${id}`),
  create: (data) => axios.post(`${API}/transfers`, data),
  update: (id, data) => axios.put(`${API}/transfers/${id}`, data),
  delete: (id) => axios.delete(`${API}/transfers/${id}`),
  execute: (id) => axios.post(`${API}/transfers/${id}/execute`),
  setPending: (id) => axios.post(`${API}/transfers/${id}/pending`),
  reject: (id, data) => axios.post(`${API}/transfers/${id}/reject`, data),
  downloadPdf: (id) => axios.get(`${API}/transfers/${id}/pdf`, { responseType: 'blob' }),
};

// Transfers V2 API
export const transfersV2Api = {
  getAll: (params = {}) => axios.get(`${API}/transfers-v2`, { params }),
  getById: (id) => axios.get(`${API}/transfers-v2/${id}`),
  create: (data) => axios.post(`${API}/transfers-v2`, data),
  update: (id, data) => axios.put(`${API}/transfers-v2/${id}`, data),
  delete: (id) => axios.delete(`${API}/transfers-v2/${id}`),
  execute: (id) => axios.post(`${API}/transfers-v2/${id}/execute`),
  setPending: (id) => axios.post(`${API}/transfers-v2/${id}/pending`),
  reject: (id, data) => axios.post(`${API}/transfers-v2/${id}/reject`, data),
  downloadPdf: (id) => axios.get(`${API}/transfers-v2/${id}/pdf`, { responseType: 'blob' }),
};

// Cheques API
export const chequesApi = {
  getAll: (params = {}) => axios.get(`${API}/cheques`, { params }),
  getById: (id) => axios.get(`${API}/cheques/${id}`),
  create: (data) => axios.post(`${API}/cheques`, data),
  update: (id, data) => axios.put(`${API}/cheques/${id}`, data),
  delete: (id) => axios.delete(`${API}/cheques/${id}`),
  execute: (id) => axios.post(`${API}/cheques/${id}/execute`),
  setPending: (id) => axios.post(`${API}/cheques/${id}/pending`),
  reject: (id, data) => axios.post(`${API}/cheques/${id}/reject`, data),
  downloadPdf: (id) => axios.get(`${API}/cheques/${id}/pdf`, { responseType: 'blob' }),
};

// Audit Logs API
export const auditLogsApi = {
  getAll: (params = {}) => axios.get(`${API}/audit-logs`, { params }),
};

// Communication API
export const communicationApi = {
  sendEmail: (data) => axios.post(`${API}/email/send`, data),
  sendSMS: (data) => axios.post(`${API}/sms/send`, data),
};

// Auth API
export const authApi = {
  login: (data) => axios.post(`${API}/auth/login`, data),
  register: (data) => axios.post(`${API}/auth/register`, data),
  me: () => axios.get(`${API}/auth/me`),
  changePassword: (data) => axios.post(`${API}/auth/change-password`, data),
  resetPassword: (data) => axios.post(`${API}/auth/reset-password`, data),
  updateProfile: (data) => axios.put(`${API}/auth/profile`, data),
};

// 2FA API
export const twoFactorApi = {
  setup: () => axios.post(`${API}/auth/2fa/setup`),
  verify: (data) => axios.post(`${API}/auth/2fa/verify`, data),
  disable: (data) => axios.post(`${API}/auth/2fa/disable`, data),
};

// Users API
export const usersApi = {
  getAll: () => axios.get(`${API}/users`),
  getById: (id) => axios.get(`${API}/users/${id}`),
  update: (id, data) => axios.put(`${API}/users/${id}`, data),
  delete: (id) => axios.delete(`${API}/users/${id}`),
  create: (data) => axios.post(`${API}/auth/register`, data),
};

// Statements API
export const statementsApi = {
  generate: (data) => axios.post(`${API}/statements/generate`, data),
};

// Settings API
export const settingsApi = {
  getReminders: () => axios.get(`${API}/settings/reminders`),
  updateReminders: (data) => axios.put(`${API}/settings/reminders`, data),
};

// Stats API
export const statsApi = {
  get: (params = {}) => axios.get(`${API}/stats`, { params }),
};

// Global Search API
export const searchApi = {
  search: (q) => axios.get(`${API}/search`, { params: { q } }),
};

// Activity API
export const activityApi = {
  getRecent: () => axios.get(`${API}/activity/recent`),
};

// Quotas API
export const quotasApi = {
  get: () => axios.get(`${API}/quotas`),
};

// Notifications API
export const notificationsApi = {
  getAll: () => axios.get(`${API}/notifications`),
  getUnreadCount: () => axios.get(`${API}/notifications/unread-count`),
  create: (data) => axios.post(`${API}/notifications`, data),
  markRead: (id) => axios.put(`${API}/notifications/${id}/read`),
  markAllRead: () => axios.put(`${API}/notifications/read-all`),
  delete: (id) => axios.delete(`${API}/notifications/${id}`),
};
